import 'reactflow/dist/style.css'
import { ReactFlowProvider } from 'reactflow'
import { FlowChart } from './FlowChart'

export const SelectTanks = () => {
  return (
    <>
      <div className="pb-1 font-bold" data-testid="select-tanks-title">
        Select Tanks
      </div>
      <ReactFlowProvider>
        <div data-testid="tank-flow-chart">
          <FlowChart />
        </div>
      </ReactFlowProvider>
    </>
  )
}
